import { InjectionKey, Ref } from 'vue';

// This follows the recommendation for typing Provide/Inject: https://vuejs.org/guide/typescript/composition-api.html#typing-provide-inject
export const userReferenceDialogKey = Symbol('userReferenceDialogKey') as InjectionKey<{
    query: Readonly<Ref<string>>;
    assignDisabledExplanation: Readonly<Ref<string | undefined>>;
    activeOptionId: Readonly<Ref<string | undefined>>;
    setActiveOption: (optionId: string) => void;
    clearActiveOption: (optionId: string) => void;
}>;
